var menu_trigger = document.querySelector('.nav__toggle'),
    nav = document.querySelector('.nav'),
    body = document.querySelector('body');

menu_trigger.addEventListener('click', function () {
    // Toggle classes
    menu_trigger.classList.toggle('nav__toggle--active')
    nav.classList.toggle('nav--active')
   // body.classList.toggle('overflow--hidden')
    body.classList.toggle('nav--open')

    // Accessibility
    if (menu_trigger.getAttribute('aria-expanded') === 'true') {
        menu_trigger.setAttribute('aria-expanded', 'false')
    } else {
        menu_trigger.setAttribute('aria-expanded', 'true')
    }
})

const documentBody = document.body;
function navTakeover() {
    const navDropdowns = document.querySelectorAll('.nav-link--dropdown');
    const childMenuLink = document.querySelectorAll('.nav-submenu__child-link');

    if (!navDropdowns) return;

    const toggleDropdown = (e, forceClose = false) => {
        let targetElement = e.target;

        const targetState = e.target.getAttribute("aria-expanded");

        const windowWidth = window.innerWidth;
        const elementPositionLeft = targetElement.getBoundingClientRect().left;
        let dropdownRight = false;

        if (windowWidth - elementPositionLeft <= 270) {
            dropdownRight = true;
        }

        if (targetState === "true" || forceClose) {
            targetElement.setAttribute("aria-expanded", "false");
            targetElement.classList.remove("dropdown--right");

            if (window.matchMedia('(min-width: 993px)').matches) {
                documentBody.classList.remove('takeover');
            }


        } else {
            resetTakeoverElements();
            targetElement.setAttribute("aria-expanded", "true");
            if (window.matchMedia('(min-width: 993px)').matches) {
                documentBody.classList.add('takeover');
            }

            if (dropdownRight) {
                targetElement.classList.add("dropdown--right");
            }
        }
    }

    const handleNavLinkKeydown = (e) => {
        if (e.key === "Esc" || e.key === "Escape") {
            toggleDropdown(e, true);
        }
    }

    const handleChildNavLinkClose = (e) => {
        if (e.key === "Esc" || e.key === "Escape") {
            const targetElement = e.target.closest(".nav-submenu").previousElementSibling;
            targetElement.setAttribute("aria-expanded", "false");
            targetElement.classList.remove("dropdown--right");
            if (window.matchMedia('(min-width: 993px)').matches) {
                documentBody.classList.remove('takeover');
            }
            targetElement.focus();
        }
    }

    navDropdowns.forEach(link => {
        link.addEventListener("click", toggleDropdown);
        link.addEventListener("keydown", handleNavLinkKeydown);
    });

    if (childMenuLink) {
        childMenuLink.forEach(link => {
            link.addEventListener("keydown", handleChildNavLinkClose);
        });
    }
}


function closeNavTakeover() {

    const globalNav = document.getElementById('global-nav');

    document.addEventListener('click', function (event) {
        if (documentBody.classList.contains('takeover') && !globalNav.contains(event.target)) {
            resetTakeoverElements()
            documentBody.classList.remove('takeover');
        }
    });
}
function resetTakeoverElements() {
    Array.from(document.querySelectorAll('.nav-link--dropdown')).forEach(function (el) {
        el.setAttribute("aria-expanded", "false");
        el.classList.remove("dropdown--right");
        el.parentElement.classList.remove('is-visible');
    });
}

navTakeover();
closeNavTakeover();

var sidebarToggle = document.getElementById("sidebarToggle");

if (sidebarToggle) {
    sidebarToggle.addEventListener("click", handleSidebarToggle);
}

function handleSidebarToggle(e) {
    if (e.target.getAttribute("aria-expanded") === "true") {
        e.target.setAttribute("aria-expanded", "false");
    } else {
        e.target.setAttribute("aria-expanded", "true");
    }
}